export function ShareIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M16 5a2 2 0 100 4 2 2 0 000-4zm-4 2a4 4 0 11.73 2.306l-2.034 1.162c.196.472.304.99.304 1.532 0 .543-.108 1.06-.304 1.532l2.035 1.162a4 4 0 11-.71 1.898L9.479 15.14a4 4 0 110-6.28l2.542-1.452A4.073 4.073 0 0112 7zm-5 3a2 2 0 100 4 2 2 0 000-4zm7 7a2 2 0 104 0 2 2 0 00-4 0z"
      ></path>
    </svg>
  );
}
